import React from 'react';
import './input.css'

const Input = (props) => {
    return ( 
            <fieldset className='fieldset'>
                  <h2 className='title-input'>{props.title}</h2>
                    <input 
                className='input'
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                type={props.type || "text"}
            />


            {props.error && (
                <p className='error'>
                    {props.error}
                </p>
            )}
           </fieldset>
     );
}
 
export default Input;